<template>
  <section
    :id="sectionId"
  >
    <div class="container">
      <div class="sec-header">
        <h2>
          {{ sectionTitle }}
        </h2>
      </div>
      
      <div class="sec-content">
        <slot></slot>
      </div>

      <div class="sec-footer">
        <a
          :href="topLink"
          v-smooth-scroll
        >
          <div class="topo">
            Topo
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Section',
    
    props: [
      'sectionId',
      'sectionTitle',
      'topLink',
    ],
  }
</script>

<style scoped lang="scss">
  /* Sizes */
  $baseWidth: 1150px;

  /* Variables */
  $red: #990000;

  section {
    margin: 100px 0 0 0;
    
    @media (max-width: 560px) {
      margin: 0px 0 0 0;
    }

    h2 {
      background: url('./../images/section/perg-sec-title.png') no-repeat;
      background-size: contain;

      width: 600px;
      height: 100px;

      padding: 20px 0 0 50px;
      margin: 0 0 50px 0;

      font-family: 'Eagle Lake', cursive;
      line-height: 60px;
      letter-spacing: 1px;
      font-weight: bolder;
      font-size: 25px;

      @media (max-width: 560px) {
        width: 330px;
        height: 60px;

        padding: 20px 0 0 25px;
        margin: 0 0 50px 0;

        line-height: 15px;
        font-size: 18px;
      }
    }
    h3 {
      font-family: 'Eagle Lake', cursive;
      line-height: 30px;
      letter-spacing: 1px;
      font-weight: bolder;
      font-size: 25px;
      color: $red;

      margin: 40px 0 20px 0;
      display: block;
    }
    p {
      font-family: 'Gochi Hand', cursive;

      font-size: 18px;
      line-height: 24px;

      letter-spacing: 1.5px;

      margin: 25px 0 25px 0;

      text-align: justify;
      text-justify: inter-word;

      img {
        width: calc(100% - 30px);
      }
    }

    strong, b {
      color: $red;
      font-weight: bolder;
      text-transform: uppercase;
    }

    a {
      color: #ff0000;
      font-weight: bold;

      text-decoration: none;

      &:hover { color: #000000; }
    }

    .int-section {
      margin: 0 0 30px 0;
      display: block;
    }

    .img-row {
      overflow: hidden;
    }

    .img-col {
      margin: 10px;
      border: 10px solid #FFFFFF;
    }
  }

  .columns {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .col-2 {
      width: calc(50% - 30px);
      margin: 15px;
    }
  }

  .container {
    width: $baseWidth;
    position: relative;

    margin: 0 auto;

    z-index: 2;

    overflow: hidden;

    @media (max-width: 1200px) { width: 100%; }

    .sec-content {
      background: url('./../images/section/perg-sec-middle.png') repeat-y;
      background-position: top center;

      padding: 20px 80px 20px 80px;

      @media (max-width: 560px) {
        padding: 10px 10px 10px 10px;
        background: #FFDB82;
      }
    }

    .sec {
      &-header {
        background: url('./../images/section/perg-sec-top.png') no-repeat;
        background-position: top center;

        height: 154px;

        padding: 50px 0 0 0;
        margin-bottom: -5px;
      }
      &-footer {
        background: url('./../images/section/perg-sec-bottom.png') no-repeat;
        background-position: top center;

        height: 100px;

        margin-top: -5px;

        @media (max-width: 560px) { background: #FFDB82; }

        .topo {
          background: url('./../images/section/topo.png') no-repeat;
          background-size: contain;

          width: 130px;
          height: 65px;

          margin: 0 auto;

          font-family: 'Gochi Hand', cursive;

          font-size: 25px;
          line-height: 20px;

          color: rgba(0,0,0,0.6);
          text-shadow: 2px 2px 3px rgba(255,255,255,0.1);

          letter-spacing: 1.5px;

          padding: 20px 0 0 60px;

          text-align: justify;
          text-justify: inter-word;

          &:hover {
            color: rgba(0,0,0,1);
            text-shadow: 2px 2px 3px rgba(255,255,255,0.1);
            transform: translateY(-10px);
          }
        }
      }
    }
  }
</style>